import { OnboardingForm } from '@nohara-dxdev/react-oidc';

import { paths } from '@/config/paths';

const OnboardingRoute = () => {
  return (
    <div className='mx-auto max-w-xl py-16'>
      <div className='my-8'>
        <OnboardingForm homePath={paths.home.getHref()} />
      </div>
    </div>
  );
};

export default OnboardingRoute;
